import React, {useEffect, useRef, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../shared/utils/forms/useForm";
import {typeHoursInitArray, typeHoursLabel, typologyHoursName} from "../../../common/typeHours";
import {months, monthsArrayOpt} from "../../../core/data/date";
import http from "../../../shared/utils/http";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../core/reducer/pharmacySlice";
import {dateFormatGG} from "../../../shared/utils/dateUtils";
import {exportPdf} from "../../../shared/utils/exportPdf";


export function EmployeesSituation() {
    const pharmacy = useSelector(selectSelectedPharmacy)
    const isTimeBank = !!pharmacy?.timeBank;

    const [data, setData] = useState<any>(undefined);
    const [columns, setColumns] = useState<any>([]);
    const printHandler = () => {
        setPrintView(true)
    }
    useEffect(() => {
        changeValue({value: 'work', name: 'typeHour'});
        setData(undefined)
    }, [pharmacy]);

    const structureDataTypeHour: StructureFormModel[] = [
        {
            type: formControlTypes.select,
            name: "typeHour",
            options: typeHoursInitArray.map(ele => ({
                label: (ele.timeBank && ele.timeBank !== isTimeBank) ? 'Straordinario' : ele.label,
                value: ele.name
            })),
            dataElement: {
                placeholder: "Seleziona tipologia ora",
                type: 'text',
                defaultValue: {label: 'Seleziona tipologia ore', isDefault: true, disabled: true},
            },
            col: {xs: "12", sm: "5"},
        },
    ]
    const structureDataTime: StructureFormModel[] = [
        {
            type: formControlTypes.select,
            name: "year",
            options: Array.from({length: new Date().getFullYear() - 2024 + 1}, (_, i) => new Date().getFullYear() - i).map(y => ({label: String(y), value: String(y)})),
            dataElement: {
                placeholder: "Seleziona anno",
                type: 'text',
                defaultValue: {label: 'Seleziona Anno', isDefault: true, disabled: true},
            },
            col: {xs: "12", sm: "6"},
        },
        {
            type: formControlTypes.select,
            name: "month",
            options: monthsArrayOpt,
            dataElement: {
                placeholder: "Seleziona mese",
                type: 'text',
            },
            col: {xs: "12", sm: "6"},
        },
    ]
    const submitHandler = (event: any, data?: any) => {
        http.get(`pharmacies/${pharmacy?.idDocument}/situation/${data.month}/${data.year}`).then(res => {
            setData(res.infos)
            setColumns(res.columns)
        })
    }
    const {
        dataFormatted,
        dataForm,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitHandler, {}, {typeHour: 'work'})

    const changeValueDate = (data: any, val?: any) => {
        setData(undefined)
        changeValue(data)
    }

    const [printView, setPrintView] = useState<boolean>(false)

    const pdfRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (printView) {
            exportPdf(`${pharmacy?.name}_situazione_dipendenti`, pdfRef, () => {
                window.close()
                setPrintView(false)
            })
        }
    }, [printView]);


    return (
        <AuthLayout>
            <div className="row" ref={pdfRef}>
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <div className={'d-flex align-items-center gap-3 w-100'}>
                            <h3 className={'text-nowrap mb-4'}>Situazione Dipendenti</h3>
                            <div className={'w-100'}>
                                <FormElements structure={structureDataTypeHour} changeValue={changeValue}
                                              dataForm={dataForm}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                        </div>
                        <div className={'d-flex gap-2 w-100'}>
                            <div className={'ms-auto w-100 row'}>
                                <div className="col-4">
                                </div>
                                <div className="col-8">
                                    <FormElements structure={structureDataTime} changeValue={changeValueDate}
                                                  dataForm={dataForm}
                                                  errors={errors} isSubmit={isSubmit}/>
                                </div>
                            </div>
                            {!printView && <div className={'d-flex gap-2'}>
                                <BtnPrimary title="Filtra" icon={'./assets/icons/filter.svg'} disabled={false}
                                            variant={'primary'}
                                            onClick={() => submitAction()}></BtnPrimary>
                                <BtnPrimary title="Stampa" icon={'./assets/icons/print.svg'} disabled={false}
                                            variant={'outline-primary'} className={'text-cyan-500 border-cyan-500'}
                                            onClick={() => printHandler()}></BtnPrimary>
                            </div>}
                        </div>
                    </div>

                    {data ? <div className="col">
                        <h5>
                            {(dataFormatted.typeHour === 'extraHours' && !isTimeBank) ? 'Straordinario' : typeHoursLabel[dataFormatted.typeHour]} {months[dataFormatted.month] ? `: ${months[dataFormatted.month]} - ${dataFormatted.year}` : ''}
                        </h5>
                        <table className={'table-print'}>
                            <thead>
                            <tr>
                                <th>Dipendente</th>
                                <th>Precedente</th>
                                {columns?.map((col: any) => (
                                    <th>{dateFormatGG(col.dateStart)} - {dateFormatGG(col.dateEnd)}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {data?.map((info: any) => (
                                <tr>
                                    <td>{info?.employee.name} {info?.employee.surname}</td>
                                    <td>{((isTimeBank && dataFormatted.typeHour === 'extraHours' ? ((-info.lastWeek?.minutes?.extraHoursEarnWeek || 0) + (info.lastWeek?.spentHours.extraHours || 0)) : info.lastWeek?.spentHours[dataFormatted.typeHour] || 0) / 60).toFixed(2)}</td>
                                    {columns?.map((col: any) => {
                                        const week = info.weekInfoTotal?.find((w: any) => col.dateStart === w.dateStart)
                                        return <td>{week ? ((isTimeBank && dataFormatted.typeHour === 'extraHours' ? ((-week?.minutes?.extraHoursEarnWeek || 0) + (week?.spentHours.extraHours || 0)) : (week?.spentHours[dataFormatted.typeHour] || 0)) / 60).toFixed(2) : '-'}
                                            {week && <small
                                                title={'Precedente'}>{dataFormatted.typeHour === 'extraHours' && isTimeBank ? `(${(week.minutes.extra / 60).toFixed(2)})` : ''}</small>}
                                        </td>
                                    })}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div> : <div>Filtra per anno e mese</div>}
                </div>
            </div>
        </AuthLayout>
    );
}


